import {useEffect} from "react";
import {useSignal} from "@preact/signals-react";
import {useToastSeeker} from "@ui-seeker/app";
import {isEmpty, postSubmit} from "@ui-seeker/utils";

import {WEBBACK_V2_API} from "@constants";
import {productPagesModalData} from "../@signals";


export default function useProductPagesMultimediaData() {
	const { showToast } = useToastSeeker()

	const data = useSignal({})
	const isLoading = useSignal(true)

	useEffect(() => {
		if (!isEmpty(productPagesModalData.value)) {
			if (!isLoading.value) isLoading.value = true
			// `details/show-details` (v2) replaces the legacy `details/multimedia`: it answers with
			// the gallery **and** the six long texts, which v1 used to ship inside every row of
			// `details/context`. In v2 those live in an InnoDB satellite that can only be read by
			// full primary key, so they arrive here, per row, when the drawer opens. Same body as
			// before — see dipi-webback-v2/plans/869e5pfw2--data-product-page.md F3.
			postSubmit(`${WEBBACK_V2_API}/product-page/details/show-details`, {
				productID: productPagesModalData.value.productID,
				date: productPagesModalData.value.date,
				retailer: [productPagesModalData.value.siteID]
			}).then(res => {
				// A product page with no images still has a description, rich content and its last
				// review, so an empty gallery no longer closes the drawer — the guard used to
				// require `res.images?.length` back when the response was multimedia only.
				if (!!res.skuID){
					data.value = {...productPagesModalData.value, ...res}
				} else {
					data.value = {}
					showToast.warning()
					productPagesModalData.value = {}
				}
			})
			.catch(() => {
				showToast.error()
				productPagesModalData.value = {}
			}).finally(() => isLoading.value = false)
		}
	}, [JSON.stringify(productPagesModalData.value)]);

	return {
		data: data.value,
		isLoading: isLoading.value
	}
}